




import { Component, Vue } from 'vue-property-decorator'
import BlogPostDetail from './components/BlogPostDetail.vue'

@Component({
  name: 'EditBlogPost',
  components: {
    BlogPostDetail
  }
})
export default class extends Vue {}
